import { render } from "./BundlesPage.vue?vue&type=template&id=f6b4b242&scoped=true"
import script from "./BundlesPage.vue?vue&type=script&lang=js"
export * from "./BundlesPage.vue?vue&type=script&lang=js"

import "./BundlesPage.vue?vue&type=style&index=0&id=f6b4b242&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b4b242"]])

export default __exports__